module.exports = __webpack_public_path__ + "static/media/ir.ed3de0f5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ir.svg
// module id = 2120
// module chunks = 0